import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  main: {
    borderBottom: '1px solid',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    height: 60,
    padding: '0 5vw',
    position: 'sticky',
    top: 0,
    zIndex: 20,
  },
  containerLeft: {
    display: 'flex',
    gap: 16,
    alignItems: 'center',
  },
  containerRight: {
    display: 'flex',
    gap: 22,
    alignItems: 'center',
  },
  wrapperIconText: {
    gap: 8,
    textDecoration: 'none',
    color: 'inherit',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    fontSize: 13,
    fontWeight: 500,
  },
};

// Active nav-link treatment — matches the mockup's `.navlink.active` (color +
// weight only, no underline/border) rather than the old thick bottom border.
export const activeLinkStyle = (color: string): React.CSSProperties => ({
  color,
  fontWeight: 600,
});

export const iconBtnStyle = (borderColor: string, bgColor: string): React.CSSProperties => ({
  width: 32,
  height: 32,
  borderRadius: 8,
  border: `1px solid ${borderColor}`,
  background: bgColor,
});

export default styles;
